import React from "react"
import VideoPage from "../components/video-page"

const Tentakulum4Page = () => (
  <VideoPage title="TENTAKULUM 4" path="/video/tentakulum-4.{ext}" />
)

export default Tentakulum4Page
